import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import App from './App';
import {store, persistor, history} from './redux/configureStore';
import {ConnectedRouter} from 'connected-react-router';
import './style/main.scss';
import './style/styles.scss';
import {loadTranslations, setLocale, syncTranslationWithStore} from 'react-redux-i18n';
import translations from './i18n';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';


const detectLanguage = () => {
    return 'es';
};

// eslint-disable-next-line require-jsdoc
function startApp() {
    ReactDOM.render(
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
          scriptProps={{
            async: false, // optional, default to false,
            defer: false, // optional, default to false
            appendTo: 'head', // optional, default to "head", can be "head" or "body",
            nonce: undefined, // optional, default undefined
          }}
        >
            <PersistGate loading={<div>loading</div>} persistor={persistor} onBeforeLift={() => {
                syncTranslationWithStore(store);
                store.dispatch(loadTranslations(translations));
                store.dispatch(setLocale(detectLanguage()));
                // TODO: add token management here
                // const state = store.store.getState();
                // const tokenTS = localStorage["token-ts"];
                // if (Date.now() - tokenTS > 1800000 && state.session.isLoggedIn)
                //     store.store.dispatch(actions.session.logout());
            }}>
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <App/>
                    </ConnectedRouter>
                </Provider>
            </PersistGate>
        </GoogleReCaptchaProvider>
        ,
        document.getElementById('root'),
    );
}

startApp();
